module.exports = __webpack_public_path__ + "img/delete.dd52ee64.svg";